import type { ReasonOption, SelectedReason } from '../interface/reasons';

const isOther = (o: ReasonOption): boolean => o.label.trim().toLowerCase() === 'other';

export interface SplitReasons {
  readonly pills: ReasonOption[];
  readonly other?: { readonly label: string };
  readonly listOptions: ReasonOption[];
}

export function splitReasonOptions(options: readonly ReasonOption[]): SplitReasons {
  const listOptions = options.filter((o) => o.show === 'list' && !isOther(o));
  const otherRow = options.find((o) => o.show === 'pill' && isOther(o));
  const pills = options.filter((o) => o.show === 'pill' && !isOther(o));
  if (listOptions.length === 0) {
    return { pills: options.filter((o) => o.show === 'pill'), listOptions };
  }
  return { pills, other: { label: otherRow?.label ?? 'Other' }, listOptions };
}

export function toSelectedReasons(
  options: readonly ReasonOption[],
  keys: readonly string[]
): SelectedReason[] {
  const byKey = new Map(options.map((o) => [o.key, o] as const));
  const seen = new Set<string>();
  const out: SelectedReason[] = [];
  for (const key of keys) {
    const option = byKey.get(key);
    if (!option || seen.has(key)) continue;
    seen.add(key);
    out.push({ key: option.key, label: option.label });
  }
  return out;
}
